import { inputResult } from "../Submit/SaveAnswer";


export function transformScToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    const options = input.find(".form-check");

    // if (results.answer === false){
    //     results.answer = -1;
    // } -> could replace backend logger as -1
    
    options.each((ind, obj) => {
        $(obj).find("input").prop('disabled', true);
        let [add, title] = '';
        if (Number(ind) === Number(results.answer)){
            // this option was selected
            $(obj).find("input").attr('checked', 'checked');
            if (results.answer == results.correct){
                // rightfully
                add = 'radio_klausur_correct';

            } else {
                //  was falsely selected
                add = 'radio_klausur_false';
                title = 'Diese Antwort ist falsch';
            }
        }

        if (ind == results.correct && results.answer != results.correct){
            // was not selected but should have been selected
            add = 'radio_klausur_missed';
            title = 'Diese Antwort wäre richtig gewesen';
        }

        $(obj).addClass(add);
        $(obj).attr("title", title);
    })


}